/* eslint-disable */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "../../styles/ComponentsStyles/Universal/MultiOptionsSelectorInput.style.css";
const MultiOptionsSelectorInput = ({
  name,
  label,
  style,
  values = [],
  options = [],
  setFieldValue,
}) => {
  const [selectedValues, setSelectedValues] = useState(values);
// eslint-disable-next-line 
  useEffect(() => {
    if (setFieldValue) {
      setFieldValue(selectedValues);
    }
  }, [selectedValues]);

  const handleChange = (e) => {
    const { value, checked } = e.target;
    setSelectedValues((prev) =>
      checked ? [...prev, value] : prev.filter((item) => item !== value)
    );
  };

  return (
    <div
      className="flex-col align-start g-05 overflow-hide"
      style={{ height: "15.9rem", ...style }}
    >
      <label htmlFor="multiselect" className="t-12 poppins">
        {label}
      </label>
      <div
        className="scroll-y flex-1 p-05"
        style={{ border: "2px solid var(--greenColor)", borderRadius: "6px" }}
      >
        <ul className="multiOptList flex-col h-fit radius-6">
          {options.length > 0 &&
            options.map((item, index) => (
              <li key={index}>
                <div>
                  <div></div>
                </div>
                <span>{item}</span>
                <input
                  type="checkbox"
                  name={index}
                  value={item}
                  checked={selectedValues.includes(item)}
                  onChange={handleChange}
                  className="multiOptselectorInputTag"
                />
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

MultiOptionsSelectorInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  style: PropTypes.object,
  values: PropTypes.arrayOf(PropTypes.string),
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func,
};

export default MultiOptionsSelectorInput;
